import { InjectionToken } from '@angular/core'

export interface Environment {
  langCookieName: string
  production: boolean
  logrocket: boolean
  logrocketAppID: string
  embedded: boolean
  googleAnalyticsId: string
  featureFlags: {
    [key: string]: boolean
  }
  keycloak: {
    url: string
    realm: string
    clientId: string
  }
  availableLanguages: { code: string; label: string }[]
  tabOrder: {
    [key: string]: string[]
  }
  cnEnergyView: boolean
  packageExpiryWarningDays: number
  isChina: boolean
  backoffice: boolean
  materialIconsClass: string
  cartoApiKey: string
}

export const ENVIRONMENT = new InjectionToken<Environment>('Environment configuration')
